module.exports = __webpack_public_path__ + "img/apple-tv-icon.44c7255b.svg";